<template>
  <div
    class="main-background filter-page-container"
    :style="{ height: pageHeight + 'px' }"
  >
    <div class="orders-breadcrumb">
      <button
        class="orders-back-btn"
        @click="$emit('setIsChangePage', 'home')"
        aria-label="Назад до магазину"
      >
        <chevron-left-icon class="orders-back-icon" />
      </button>
      <nav class="breadcrumb">
        <span
          class="breadcrumb-link"
          @click="$emit('setIsChangePage', 'home')"
          >Магазин</span
        >
        <chevron-right-icon class="breadcrumb-sep" />
        <span class="breadcrumb-current">Мої замовлення</span>
      </nav>
    </div>
    <button v-if="selectedId" type="button" class="all-orders" @click="showAllOrders">Усі мої замовлення</button>
    <request-state :loading="resource.loading" :error="resource.error" loading-text="Завантажуємо замовлення…" @retry="loadOrders" />
    <MyOrdersPage
      v-if="!resource.loading && !resource.error"
      :orders="orders"
      @setIsChangePage="handleSetIsChangePage"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { ChevronLeftIcon, ChevronRightIcon } from "vue-feather-icons";
import MyOrdersPage from '@/components/MyOrders.vue'
import RequestState from '../../../components/RequestState.vue'

export default {
  name: "orders-page",
  components: {
    MyOrdersPage,
    RequestState,
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  props: {
    addedToCardProducts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      pageHeight: 0,
      listHeight: 0,
    };
  },
  async mounted() {
    console.log('Orders page opened');
    if (this.selectedId) this.$store.dispatch('loadOrderDetails', this.selectedId);
    else this.loadOrders();
    this.pageHeight = window.innerHeight - 150;
    this.listHeight = window.innerHeight - 50 - 175;
    window.scrollTo(0, 0);
    document.body.addEventListener("click", (event) => {
      let target = event.target;
      target;
    });
  },
  methods: {
    showAllOrders() {
      this.$store.commit('setSelectedOrderId', null);
      this.$store.commit('setFocusedOrder', null);
      this.loadOrders();
    },
    loadOrders() {
      if (this.selectedId) return this.$store.dispatch('loadOrderDetails', this.selectedId);
      return this.$store.dispatch("getOrders", window.location.pathname.split("/").filter(Boolean)[0]);
    },
    ...mapMutations(["addPerPage"]),
    handleEnterKey() {
      const activeElement = document.activeElement;
      if (activeElement.tagName === "INPUT") {
        activeElement.blur();
      }
    },
    onOpenProduct() {
      this.$store.dispatch(
      "getOrders",
      // this.parseUrl(window.location.pathname)
      28795
    );
      this.addPerPage("home");
      this.$emit("setIsChangePage", "productInfo");
    },
    validateInput(item) {
      item.qty_item = item.qty_item.replace(/\D/g, "");

      const numericValue = parseInt(item.qty_item);
      if (numericValue > item.qty_product) {
        item.qty_item = item.qty_product.toString();
      }
    },
    goToMakeOrderPage() {
      if (this.cartElements?.items?.length) {
        this.$emit("setIsChangePage", "makeOrder");
      }
    },
    setChangeCounter(value, product) {
      let data = {
        product_id: product.product_id,
        order_id: this.getOrderId.id,
      };
      if (value === "+") {
        this.$store.dispatch("getOneMoreProduct", JSON.stringify(data));
      } else {
        this.$store.dispatch("getMinusProduct", JSON.stringify(data));
      }
    },
    deleteProduct(product) {
      let data = {
        product_id: product.product_id,
        order_id: this.getOrderId.id,
      };
      try {
        this.$store.dispatch("deleteProductFromCart", JSON.stringify(data));
      } catch (error) {
        console.log(error.message);
      }
    },
    handleSetIsChangePage(page) {
      this.$emit('setIsChangePage', page); 
    }
  },
  computed: {
    selectedId() { return this.$store.getters.selectedOrderId; },
    resource() { return this.selectedId ? this.$store.getters.resources.orderDetails : this.$store.getters.resources.orders; },
    orders() {
      return this.selectedId ? (this.$store.getters.focusedOrder ? [this.$store.getters.focusedOrder] : []) : this.$store.getters.getOrders || [];
    }
  },
  watch: {},
};
</script>

<style scoped>
.all-orders { min-height: 44px; padding: 8px 16px; background: #fff; color: #075a63; border: 0; text-align: left; cursor: pointer; }
.main-background {
  background: #fff;
}
.orders-breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.orders-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f0f0f0;
  border: none;
  cursor: pointer;
  flex: 0 0 auto;
  transition: background 0.2s ease;
}
.orders-back-btn:hover {
  background: #e4e4e4;
}
.orders-back-icon {
  width: 20px;
  height: 20px;
  color: #333;
}
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter;
  font-size: 14px;
  line-height: 18px;
}
.breadcrumb-link {
  color: #16abb8;
  font-weight: 500;
  cursor: pointer;
}
.breadcrumb-link:hover {
  text-decoration: underline;
}
.breadcrumb-sep {
  width: 14px;
  height: 14px;
  color: #b0b0b0;
}
.breadcrumb-current {
  color: #707070;
  font-weight: 400;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}

.back-button-icon {
  position: absolute;
}

.back-button-text {
  text-align: center;
}

.filter-page-container {
  display: flex;
  flex-direction: column;
}
.bottom-filter-button-container {
  background: #fff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  margin-top: auto;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}
.return-to-shop {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  color: #16abb8;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #16abb8;
}
.cart-page-container-list {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
  height: 100%;
  overflow-y: scroll;
}
.cart-page-item {
  position: relative;
  display: flex;
  gap: 24px;
  padding: 6px 16px 16px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.product-counter-container {
  display: flex;
  gap: 4px;
  margin-left: auto;
}
.product-counter-button {
  border: 1px solid #c4c4c4;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
}
.product-counter-button-icon {
  width: 8px;
  height: 8px;
}
.product-counter-input {
  width: 40px;
  height: 24px;
  border-radius: 4px;
  background: #f0f0f0;
  border: none;
  text-align: center;
  outline-offset: 0;
  outline: 0;
  color: #707070;
  text-align: center;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}
.cart-page-item-image {
  border-radius: 12px;
  border: 1px solid #d2d6db;
  width: 140px;
  height: 140px;
  cursor: pointer;
}
.cart-page-item-name {
  color: #333;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  padding-right: 15px;
  cursor: pointer;
}
.cart-page-item-code {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-top: 14px;
}
.cart-page-item-price {
  color: #16abb8;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-top: 19px;
  margin-bottom: 7px;
}
.final-price-container {
  display: flex;
  justify-content: space-between;
}
.final-price {
  color: #121212;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 5px;
}

.delete-product-cart-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.delete-button-icon {
  color: #686868;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }

  .filter-page-container {
    max-width: 1400px;
    margin: 0 auto;
    min-height: auto;
  }

  .cart-page-container-list {
    max-width: 1400px;
    margin: 0 auto;
    /* padding: 40px; */
  }
}
</style>
